// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import * as S from './Quickstart.styles';

export const Quickstart = () => {
  const [createQueueExpanded, setCreateQueueExpanded] = useState(false);
  const toggleCreateQueue = (ev: React.SyntheticEvent) => {
    ev.stopPropagation();
    setCreateQueueExpanded(state => !state);
  };

  const [startAgentExpanded, setStartAgentExpanded] = useState(false);
  const toggleStartAgent = (ev: React.SyntheticEvent) => {
    ev.stopPropagation();
    setStartAgentExpanded(state => !state);
  };

  const [launchJobExpanded, setLaunchJobExpanded] = useState(false);
  const toggleLaunchJob = (ev: React.SyntheticEvent) => {
    ev.stopPropagation();
    setLaunchJobExpanded(state => !state);
  };

  return (
    <S.Panel>
      <S.Header>
        <S.Title>Quickstart</S.Title>
      </S.Header>
      <S.Message isStatic>
        Follow these steps to set up and use a simple Docker queue on your local
        machine.
      </S.Message>
      <S.Divider />
      <S.Section isSelected={createQueueExpanded} onClick={toggleCreateQueue}>
        <S.SectionHeader>
          <Button
            variant="ghost"
            size="small"
            icon={createQueueExpanded ? 'chevron-down' : 'chevron-next'}
            onClick={toggleCreateQueue}
            style={{marginRight: '8px'}}
          />
          1. Create a launch queue
        </S.SectionHeader>
      </S.Section>
      {createQueueExpanded && (
        <S.Message lightText={true}>Click on 'Create a queue'</S.Message>
      )}
      <S.Divider />
      <S.Section isSelected={startAgentExpanded} onClick={toggleStartAgent}>
        <S.SectionHeader>
          <Button
            variant="ghost"
            size="small"
            icon={startAgentExpanded ? 'chevron-down' : 'chevron-next'}
            onClick={toggleStartAgent}
            style={{marginRight: '8px'}}
          />
          2. Start a launch agent
        </S.SectionHeader>
      </S.Section>
      {startAgentExpanded && (
        <S.Message lightText={true}>
          Click "View queue" and then navigate to the "Agents" tab, then follow
          the instructions at the top of the page to start a launch agent on
          your computer.
        </S.Message>
      )}
      <S.Divider />
      <S.Section
        isSelected={launchJobExpanded}
        isBottom={true}
        onClick={toggleLaunchJob}>
        <S.SectionHeader>
          <Button
            variant="ghost"
            size="small"
            icon={launchJobExpanded ? 'chevron-down' : 'chevron-next'}
            onClick={toggleLaunchJob}
            style={{marginRight: '8px'}}
          />
          3. Launch a job
        </S.SectionHeader>
      </S.Section>
      {launchJobExpanded && (
        <S.Message lightText={true}>
          <ul>
            <li>
              Create a job from any python script that uses{' '}
              <S.InlineCode>wandb.init()</S.InlineCode>
            </li>
            <li>
              Navigate to the 'Jobs' tab from any project to see a list of
              available jobs.
            </li>
            <li>
              Click the 'Launch' button to configure the job and run it on your
              queue!
            </li>
          </ul>
        </S.Message>
      )}
    </S.Panel>
  );
};
